import { Stack } from 'expo-router';
import Head from 'expo-router/head';
import React from 'react';

import { OffersAndRewardsScreen } from '@fhs/loyalty';
import { useShouldShowSectionsHeader } from '@fhs/loyalty/src/screens/offers-and-rewards/hooks';
import { ErrorBoundary, ErrorCard, VisuallyHiddenH1, useMqSelect } from '@fhs/ui';
import { withStoreSelected } from '@fhs-legacy/frontend/src/components/store-selected';

import { getScreenTitleHeader } from '../../../components/get-screen-title-header';

export { ErrorBoundary } from '@fhs/routing/src/components/page-dev-error-boundary';

function OffersAndRewards() {
  const isDesktop = useMqSelect({ $gteDesktop: true }, false);
  const shouldShowSectionsHeader = useShouldShowSectionsHeader();
  return (
    <>
      <Head>
        <title>Loyalty - Firehouse Subs</title>
      </Head>
      {isDesktop && <VisuallyHiddenH1 title="Loyalty" />}
      <Stack.Screen
        options={{
          header: getScreenTitleHeader({
            cannotGoBackHref: '/menu',
            showDivider: shouldShowSectionsHeader ? false : true,
          }),
          headerShown: !isDesktop,
          title: 'Loyalty',
        }}
      />
      <ErrorBoundary fallback={<ErrorCard />}>
        <OffersAndRewardsScreen />
      </ErrorBoundary>
    </>
  );
}

export default withStoreSelected(OffersAndRewards);
